<template>
    
    <div>
    <Loader />
        <!---Map-->      
        <div v-if="userAllPlants!=null" id="map-container" class="full-map animated fadeIn">

       <MglMap 
        :accessToken="accessToken"
        :mapStyle="mapStyle" 
        :center="centerMap" 
        :zoom="zoom"
        container="map-container"
        :speed="1"
        @load="onMapLoaded"
        >
        <MglMarker  v-for="(plant,index) in this.userAllPlants" :key="`${index}-${plant.id}`"
        :coordinates= "[plant.address.long,plant.address.lat]"
        color="blue" >
            <img slot="marker" src="/img/marker.png" style="height:40px; width:auto"/>
            <!-- Visualizzazione Popup con nome dell'impianto -->
            <!-- <MglPopup>
                  <div>{{plant.plantname}}</div>
            </MglPopup> -->
        </MglMarker>    

       </MglMap>


       </div>

        <!--Over Map-->
        <div id="allPlantsSearchContainer" v-if="userAllPlants!=null" :class="{'over-map':true, expanded: listVisible}">
            <b-button 
                :pressed="false"
                class="typo-label"
                variant="warning"
                @click="backToSummary"
              >Torna al riepilogo</b-button>
        </div>  
        
        
        
    </div>


</template>

<script>

import { Auth } from 'aws-amplify'
import { API } from 'aws-amplify'
//import * as Axios from 'axios'

import AddPlant from '@/components/AddPlant'
import { mapState, install } from 'vuex';

import Mapbox from "mapbox-gl";
import { MglMap,MglMarker, MglPopup} from "vue-mapbox";
import router from '../router/approuter'
import {showAt, hideAt} from 'vue-breakpoints'


export default {
    name: 'AllPlants',
    components: {
        AddPlant,
        MglMap,
        MglMarker,
        MglPopup,
        hideAt, showAt

    },    
    props: ['installerId','adminMode'],
    data() {
        return {
            userId: null,
            pageloading: true,
            searchPlant: "",
            accessToken: 'pk.eyJ1IjoiYmVnaGVsbGlkZXYiLCJhIjoiY2s4dHdzMTB1MDN2YjNwbXd3aTBjZ25payJ9.bGime-PtFWnugxAAL1G3yQ',
            mapStyle: 'mapbox://styles/mapbox/outdoors-v11',
            centerMap:[11,48],
            zoom:4,
            selectedPlant:"",
            listVisible: false

        }
    },
    created() {
        this.map = null;
    },
    mounted() {
        console.log("allplants mounted, adminMode:" + this.adminMode+", installerId:" + this.installerId, this.userAllPlants);
        if (this.adminMode == true) {
            this.userId = this.installerId;
            return;
        }
        if (this.userAllPlants==null && !this.$store.state.connecting && this.$store.state.socket != null && this.$store.state.socket.isConnected) {
            this.$store.dispatch('loadAllPlants',  this.$route.params.userId);
        }
        else
        {
            console.log("MOUNTED")
        }
    },
    updated() {
        if (this.userAllPlants==null && !this.$store.state.connecting && this.$store.state.socket != null && this.$store.state.socket.isConnected) {
            this.$store.dispatch('loadAllPlants',  this.$route.params.userId);
        }
    },
    computed: {
         ...mapState(['loading']),
        
        userAllPlants() {
            var all = this.$store.state.userAllPlants;
            var latCenter=0;
            var longCenter=0;
            var self = this;
            if (all == null || all.length=="0") return null;    
            if (this.adminMode == true) {
                all = this.$store.state.userAllPlants.filter((p) => {
                    var installer = p.plant_users.find((u) => {
                        return u.role == 'installer' && u.userid == self.installerId;
                    })
                    return installer != null;
                });
            }       
            console.log("ALL PLANTS", all);
            return all;
        },

        filteredList() {
            return this.userAllPlants.filter(plant => {
            return (plant.plantname.toLowerCase().includes(this.searchPlant.toLowerCase()) 
                    || plant.address.street.toLowerCase().includes(this.searchPlant.toLowerCase())
                    || plant.address.city.toLowerCase().includes(this.searchPlant.toLowerCase())
                    || plant.address.prov.toLowerCase().includes(this.searchPlant.toLowerCase())
                    || plant.address.country.toLowerCase().includes(this.searchPlant.toLowerCase())
                    )
        })
        }
  

        },  
     watch: {
        loading(val,oldval) {
            console.log("loading changed:" + val);
            if (val == false && this.userAllPlants == null ) {
                this.$store.dispatch('loadAllPlants', this.$route.params.userId);
            }
        }
     },        
    methods: {   
          lensClicked(e) {
              e.preventDefault();
              this.listVisible = true;
          },
          toggleMap(e) {
            e.preventDefault();
            this.listVisible = !this.listVisible;
            console.log("toggle map " + this.listVisible);
          },
          openPlant(plant)
          {
            let recPlants = this.$store.state.userLastPlants
            console.log("BEFORE",recPlants);
            for (var k=0;k<recPlants.length;k++)
            {
                if(recPlants[k].id==plant.id)
                {
                    var index=k;
                    console.log("INDEX",index);
                }
            }
            recPlants.splice(index,1)
            recPlants.unshift(plant)
            console.log("AFTER",recPlants);
            this.$store.state.userLastPlants = recPlants
            router.push({ name: 'HomeImpianto', params: { pid: plant.id } })  
          },
          selectPlant(id)
          { 
              this.selectedPlant=id;
              console.log("SELECTED",this.selectedPlant);
              this.listVisible = false;
          },
          getTotalLamps(plant)
          {
              var totalLamps=0;
              for(var k=0; k<plant.controlunits.length; k++)
                  totalLamps=totalLamps+parseInt(plant.controlunits[k].num_lamp_found); 
              console.log("TOTAL LAMPS: " , totalLamps);     
              return totalLamps;
          },
          getError(plant)
          {
              var plantError=false;
              for(var k=0; k<plant.controlunits.length; k++)
                  {
                    if(parseInt(plant.controlunits[k].num_lamp_error)>0)
                    plantError=true;
                  }  
              return plantError;
          },
          setCenterMap(){
             //find center of all the plants 
             var latCenter=0;
             var longCenter=0;
             var centerReal=[0,0];
             for (var j=0; j<this.userAllPlants.length;j++)
                {
                   latCenter=latCenter+parseFloat(this.userAllPlants[j].address.lat);
                   longCenter=longCenter+parseFloat(this.userAllPlants[j].address.long);
                }
                latCenter=latCenter/this.userAllPlants.length;
                longCenter=longCenter/this.userAllPlants.length;
                centerReal=[longCenter,latCenter];
                console.log("CENTERMAP",centerReal);
                return centerReal
            },
           
           async onMapLoaded(event){
                console.log("MAP LOADED");
                this.map=event.map;
                const asyncActions = event.component.actions;
                
                //go to center
                const newParams = await asyncActions.flyTo({
                    center: this.setCenterMap(),
                    zoom:this.zoom,
                    speed: 1
                 });

            },

            backToSummary() {
                router.push({ name: 'BAHome'})  
            },
        }

}
</script>

